<template>
  <div class="summary-position">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统统计</el-breadcrumb-item>
      <el-breadcrumb-item>数据下载指标统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col>
        <div style="margin-bottom: 12px;">
          <el-date-picker
            @change="dateChange"
            v-model="daterangevalue"
            type="daterange"
            :unlink-panels="true"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <el-card class="page-card" v-loading="loading">
          <div id="summary-map"></div>
          <el-radio-group
            @change="positionChange"
            v-model="currentPosition"
            size="medium"
            style="position: absolute; right: 20px; top: 20px;">
            <el-radio-button label="世界"></el-radio-button>
            <el-radio-button label="中国"></el-radio-button>
          </el-radio-group>
          <el-table
            :data="positionData"
            :border="true"
            :show-header="true"
            show-summary
            height="564"
            style="width: 220px; position: absolute; left: 20px; top: 56px;">
            <el-table-column prop="cnname" label="合计"></el-table-column>
            <el-table-column prop="times" :label="total"></el-table-column>
          </el-table>
        </el-card>

        <el-row :gutter="20">
          <el-col :span="9">
            <el-card class="page-card" style="margin-top: 20px;">
              <div id="summary-tool"></div>
            </el-card>
          </el-col>
          <el-col :span="15">
            <el-card class="page-card" style="margin-top: 20px;">
              <div id="summary-target-top"></div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
  
<script>
import axios from 'axios';
import * as echarts from 'echarts';
import worldGeoJson from '../assets/world.json';
import chinageoJson from '../assets/china.json';

echarts.registerMap('world', worldGeoJson);
echarts.registerMap('china', chinageoJson);
let mapChart = null;
let barChart = null;
let pieChart = null;

export default {
  name: 'SummaryPositionData',
  data() {
    return {
      positionData: [],
      daterangevalue: '',
      currentPosition: '世界',
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  computed:  {
    total(){
      let sum = 0;
      this.positionData && this.positionData.forEach((d) => {
        sum += d.times;
      });
      return `${sum}`;
    },
  },
  methods: {
    dateChange(v) {
      this.getData(v);
    },

    positionChange(v) {
      this.getPositionData(v, this.daterangevalue);
    },

    getData(daterange='') {
      const params = { daterange };

      this.getPositionData(this.currentPosition, daterange);

      axios.post('/iapi/getsummytool', params).then((res) => {
        if (res.data.errcode === 0) {
          this.initEcharts2(res.data.data);
        }
      });

      axios.post('/iapi/getsummytargettop', params).then((res) => {
        if (res.data.errcode === 0) {
          this.initEcharts3(res.data.data);
        }
      });
    },

    getPositionData(currentPosition, daterange='') {
      this.loading = true;
      const params = { daterange };
      let url = '/iapi/getsummyposition';
      if (currentPosition === '中国') {
        url = '/iapi/getsummychinaposition';
      }
      axios.post(url, params).then((res) => {
        this.loading = false;
        if (res.data.errcode === 0) {
          if (currentPosition === '中国') {
            this.initChinaEcharts(res.data.data);
          } else {
            this.initWorldEcharts(res.data.data);
          }
        }
      });
    },

    initWorldEcharts(data) {
      if(mapChart) {
        mapChart.dispose();
      }
      const values = data.map(d => d.value);
      this.positionData = data.map(d => {
        return {
          ...d,
          times: d.value,
          cnname: d.country,
          value: Math.log10(d.value),
        }
      }).sort((a, b) => b.value - a.value);
      let min = 1;
      let max = 2;
      if (values.length) {
        min = Math.log10(Math.min(...values));
        max = Math.log10(Math.max(...values));
      }
      mapChart = echarts.init(document.getElementById('summary-map'));
      const option = {
        title: {
          text: '数据下载次数统计',
          lineHeight: 20,
          padding: 0,
        },
        grid: {
          left: 220,
          right: 0,
          bottom: 0,
          top: 0,
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: ({data}) => {
            if (data) {
              return `${data.country}<br/>${data.times} 次下载记录`
            }
          }
        },
        visualMap: {
          min: min,
          max: max,
          calculable: true,
          // text: ['10<sup>'+max+'</sup>', '10<sup>'+min+'</sup>'], // 自定义显示的最小和最大刻度文本
          inRange: {
            color: ['lightskyblue', 'yellow', 'orange']
          },
          itemWidth: 12,
          itemHeight: 240,
          top: 'middle',
          hoverLink:true,
          right: 240,
          // axisLabel: {
          //   formatter: function (value) {
          //       // 将对数刻度值转换为 10 的 n 次方形式
          //       return '10<sup>' + value + '</sup>';
          //   }
          // },
          formatter: function (value) {
            return '10^' + value.toFixed(2);
          }
        },
        series: [
          {
            name: '数据下载次数统计',
            type: 'map',
            map: 'world',
            roam: true,
            label: {
              show: false
            },
            data: this.positionData,
          }
        ]
      }
      mapChart.setOption(option);
      mapChart.on('click', (params) => {
        if (params.data) {
          const { name } = params.data;
          if (name === 'China') {
            mapChart.dispose();
            this.currentPosition = '中国';
            this.getPositionData(this.currentPosition, this.daterangevalue)
          }
        }
      });
    },

    initChinaEcharts(data) {
      if(mapChart) {
        mapChart.dispose();
      }
      const values = data.map(d => d.value);
      let min = 1;
      let max = 2;
      if (values.length) {
        min = Math.min(...values);
        max = Math.max(...values);
      }
      const nameMap = {
        '北京市': '北京市',
        '贵州': '贵州省',
        '广东': '广东省',
        '上海': '上海市',
        '新疆': '新疆维吾尔自治区',
        '河北省': '河北省',
        '山东省': '山东省',
        '海南': '海南省',
        '湖南': '湖南省',
        '江苏省': '江苏省',
        '陕西': '陕西省',
        '重庆': '重庆市',
        '云南': '云南省',
        '江西': '江西省',
        '山西': '山西省',
        '浙江省': '浙江省',
        '内蒙古': '内蒙古自治区',
        '四川省': '四川省',
        '辽宁': '辽宁省',
        '广西': '广西壮族自治区',
        '湖北省': '湖北省',
        '河南': '河南省',
        '黑龙江省': '黑龙江省',
        '甘肃': '甘肃省',
        '安徽': '安徽省',
        '福建省': '福建省',
        '天津市': '天津市',
        '吉林': '吉林省',
        '宁夏': '宁夏回族自治区',
        '西藏': '西藏自治区',
        '青海': '青海省',
      };
      this.positionData = data.map((d) => {
        let name = d.name;
        if (nameMap[name]) {
          name = nameMap[name];
        }
        return {
          ...d,
          name,
          cnname: name,
          times: d.value,
        }
      }).sort((a, b) => b.value - a.value);

      mapChart = echarts.init(document.getElementById('summary-map'));
      const option = {
        title: {
          text: '数据下载次数统计',
          lineHeight: 20,
          padding: 0,
        },
        grid: {
          left: 220,
          right: 0,
          bottom: 0,
          top: 0,
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: ({data}) => {
            if (data) {
              return `${data.name}<br/>${data.value} 次下载记录`
            }
          }
        },
        visualMap: {
          min: min,
          max: max,
          calculable: true,
          inRange: {
            color: ['lightskyblue', 'yellow', 'orange']
          },
          itemWidth: 12,
          itemHeight: 240,
          top: 'middle',
          hoverLink:true,
          right: 400,
          formatter: function (value) {
            return value;
          }
        },
        series: [
          {
            name: '数据下载次数统计',
            type: 'map',
            map: 'china',
            roam: true,
            label: {
              show: false
            },
            data: this.positionData,
          }
        ]
      }
      mapChart.setOption(option);
    },

    initEcharts2(data) {
      if(pieChart) {
        pieChart.dispose();
      }
      pieChart = echarts.init(document.getElementById('summary-tool'));
      const option = {
        title: {
          text: '数据下载方式统计',
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: 20,
        },
        toolbox: {
          feature: {
              dataView: {show: true, readOnly: false},
              restore: {},
              saveAsImage: {}
          }
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      if (data.length) {
        pieChart.setOption(option);
      } else {
        pieChart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center'
          }
        });
      }
    },

    initEcharts3(data) {
      if(barChart) {
        barChart.dispose();
      }
      barChart = echarts.init(document.getElementById('summary-target-top'));
      const option = {
        title: {
          text: 'TOP10源下载次数',
        },
        grid: {
          bottom: 120,
        },
        tooltip: {
          trigger: 'item',
        },
        toolbox: {
          feature: {
              dataView: {show: true, readOnly: false},
              restore: {},
              saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          data: data.map((item) => {
            return item.target;
          }),
          axisLabel: {
            rotate: 45,
            interval: 0
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: data.map((item) => {
              return item.download_times;
            }),
            type: 'bar',
            barWidth: 36,
            label: {
              show: true, 
              position: 'top',
              formatter: '{c}',
              color: '#000',
              fontSize: 14,
            }
          }
        ]
      };
      if (data.length) {
        barChart.setOption(option);
      } else {
        barChart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center'
          }
        });
      }
    },
  },
};
</script>

<style scoped>
#summary-map {
  height: 600px;
}
#summary-tool {
  height: 600px;
}
#summary-target-top {
  height: 600px;
}
.summary-position {
  padding: 24px 56px;
}
.admin-path {
  margin-bottom: 16px;
}
.page-card {
  position: relative;
}
</style>
